<div class="sheet">
  @if (formGroup) {
    <form id="charge-to-my-room" [formGroup]="formGroup" (ngSubmit)="confirm()">
      <div class="line">
        <h4>{{ 'HOTEL_PREFERENCE.ROOM' | translate }}</h4>
        <img class="icon-xl" (click)="close()" [src]="'close.svg' | themeSource">
      </div>

      <mat-form-field>
        <mat-label>{{ 'BILL.NAME' | translate }}</mat-label>
        <input matInput required formControlName="name">
        @if (formGroup.controls['name'].errors && submitted) {
          <mat-error>{{ 'COMMON.REQUIRED' | translate }}!</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'BILL.ROOM_NUMBER' | translate }}</mat-label>
        <input matInput required formControlName="roomNumber">
        @if (formGroup.controls['roomNumber'].errors && submitted) {
          <mat-error>{{ 'COMMON.REQUIRED' | translate }}!</mat-error>
        }
      </mat-form-field>

      <button class="btn" type="submit">{{ 'ACTIONS.SUBMIT' | translate }}</button>
    </form>
  }
</div>
